import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestsTrackerService } from '@services/requests-tracker/requests-tracker.service';
import { Observable, RetryConfig, catchError, finalize, retry, tap, throwError } from 'rxjs';

@Injectable()
export class RequestTrackerInterceptor implements HttpInterceptor {
  constructor(private requests_tracker: RequestsTrackerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tracked_request: HttpRequest<any> = request.clone();
    const retry_config: RetryConfig = this.requests_tracker.startRequestTracking(tracked_request);

    return next.handle(tracked_request).pipe(
      retry(retry_config),

      catchError((error: any) => {
        this.requests_tracker.endRequestTracking(tracked_request, error);
        return throwError(() => error);
      }),

      tap({
        next: (res: HttpEvent<any>) => {
          if (res.type === HttpEventType.Response && !(res instanceof HttpErrorResponse))
            this.requests_tracker.endRequestTracking(tracked_request, true);
        },
        complete: () => this.requests_tracker.endRequestTracking(tracked_request, true)
      }),
      finalize(() => this.requests_tracker.endRequestTracking(tracked_request, true))
    );
  }
}
